import { FormSubmitButton } from '../../components/Button/PrimaryButton';
import { FormComponent } from '../../components/FormCom/FormComponent';
import { TextInputField } from '../../components/FormCom/FormField';
import { HideableTextFormField } from '../../components/FormCom/HideableTextFormField';
import useAuth from '../../hooks/useAuth';
import {
  SignInDataType,
  signinInitialValues,
  SignInSchema,
} from '../../models/auth/signIn.model';

export const SignInArea = () => {
  const { loading, loginUser } = useAuth();

  const onSubmit = async (values: SignInDataType) => {
    loginUser(values);
  };

  return (
    <FormComponent
      initialValues={signinInitialValues}
      schema={SignInSchema}
      onSubmit={onSubmit}
    >
      <TextInputField
        label="User Name"
        name="username"
        type="email"
        placeholder="User Name"
      />
      <HideableTextFormField
        label="Password"
        name="password"
        type="password"
        placeholder="Password"
      />

      <FormSubmitButton type="submit" showIcon={loading}>
        Sign In
      </FormSubmitButton>
    </FormComponent>
  );
};
